import React from "react";
import FormModal from "components/Modal/EditFormModal";
import { Form } from "antd";
import CategoryForm from "./CategoryForm";
import { useSelector } from "react-redux";

const EditCategory = () => {
  const [form] = Form.useForm();
  const curdProps = useSelector((state) => state.CurdR);
  const { Edit_Category_Modal, Loader, initialValues } = curdProps;

  return (
    <FormModal
      modalTitle="Edit Category"
      submitButtonText="Update"
      cancelButtonText="Cancel"
      editApiRequest="EditRecord"
      apiLoader="StartSpinner"
      editApiMethod="PUT"
      editApiName="editHealthCategory"
      ModalName="Edit_Category_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Edit_Category_Modal ? Edit_Category_Modal : false}
      initialValues={initialValues}
      width={500}
      form={form}
      recordName="categoryList"
    >
      <CategoryForm />
    </FormModal>
  );
};

export default EditCategory;
